import React from 'react';
import { mount } from 'enzyme';
import Tooltip from '../Tooltip';

describe('#Tooltip', () => {
  let props, wrapper;

  beforeAll(() => {
    props = {
      left: 20,
      right: 40,
      topArrow: false,
    };
    wrapper = mount(<Tooltip {...props} />);
  });

  it('render with prop values', () => {
    const tooltipComponent = wrapper.find(Tooltip);

    expect(wrapper).toBeTruthy();
    expect(tooltipComponent.prop('left')).toEqual(20);
    expect(tooltipComponent.prop('right')).toEqual(40);
    expect(tooltipComponent.prop('topArrow')).toEqual(false);
  });
});
